module.exports = __webpack_public_path__ + "img/content_voice.191326df.png";